<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined
        min-height="180px"
      >
        <v-row class="pa-4" v-if="!loading" >

          <v-col class="pl-4" cols="12">
            <h2 class="font-weight-regular">{{ type_sponsor.name }}:</h2>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-for="(sponsor) in sponsors" :key="sponsor.id">
            <cardSponsor :sponsor="sponsor"/>
          </v-col>
          
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'sponsorsEdition', params: { edition_id:this.edition_id, types_sponsor_id: this.types_sponsor_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import cardSponsor from '@/components/card/cardSponsor'

  export default {
    name: 'newSponsorsEdition',
    components:{cardSponsor},

    data: () => ({
      loading:true,

      sponsors:[],
      type_sponsor:[],

      edition_id: null,
      types_sponsor_id: null,
      sponsor_id: null,
    }),

    methods:{
      async getSponsorsEdition(){
        await axios.get('admin/editions/'+this.edition_id+'/types-sponsors/'+this.types_sponsor_id+'/sponsors/all').then(response =>{
          this.type_sponsor = response.data.data.type_sponsor
          this.sponsors = response.data.data.sponsors
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id
      this.types_sponsor_id = this.$route.params.types_sponsor_id
      this.getSponsorsEdition()
    },
  }
</script>
